import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../../../components/base/PageMeta';
import JsonLd from '../../../components/base/JsonLd';
import FloatingCtaBar from '../../../components/feature/FloatingCtaBar';

const tools = [
  // ── PROP TRADING FIRMS ──
  {
    name: 'OneUpTrader',
    slug: 'oneuptrader',
    tagline: 'Elite Prop Trading Firm for Futures',
    desc: 'OneUpTrader is a leading proprietary trading firm offering funded futures accounts. Pass the evaluation, get funded, and keep up to 90% of your profits. Supports NinjaTrader, Tradovate, and more.',
    tags: ['Prop Trading', 'Funded Account', 'Futures', 'Evaluation'],
    rating: 4.7,
    reviews: 1820,
    price: 'From $147/mo',
    priceType: 'paid',
    link: 'https://www.oneuptrader.com?ref=nzrmyjc',
    logoIcon: 'ri-line-chart-line',
    logoGrad: 'from-emerald-500 to-teal-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/f89c5e6b-e93e-4d32-a2d4-58a5b7ff2346_oneup-trader.jpg?v=067934203c888d2b48568530ec12681b',
    badge: 'Top Pick',
    badgeColor: 'bg-amber-100 text-amber-700',
  },
  {
    name: 'The5ers',
    slug: 'the5ers',
    tagline: 'Professional Forex Prop Firm with Growth Program',
    desc: 'The5ers is a globally recognized forex proprietary trading firm with a unique growth scaling plan. Trade with funded capital from $6K up to $4M, and scale your account based on consistent performance.',
    tags: ['Prop Trading', 'Forex', 'Funded Account', 'Scaling Plan'],
    rating: 4.8,
    reviews: 2410,
    price: 'From $269',
    priceType: 'paid',
    link: 'https://www.the5ers.com/?afmc=r1f',
    logoIcon: 'ri-trophy-line',
    logoGrad: 'from-teal-500 to-cyan-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/9af4f5c3-222e-4bf6-baad-45a6cd4d558c_the5ers.jpg?v=9ee8d41221945a6df373bb2c1de5b3de',
    badge: "Editor\'s Choice",
    badgeColor: 'bg-teal-100 text-teal-700',
  },
  {
    name: 'Funded Trading Plus',
    slug: 'funded-trading-plus',
    tagline: 'Reliable CFD & Forex Funded Trader Platform',
    desc: 'Funded Trading Plus offers flexible prop trading evaluations for forex and CFD traders. Instant funding options, up to 90% profit split, and a straightforward challenge process designed for serious traders.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'CFD'],
    rating: 4.6,
    reviews: 1340,
    price: 'From $99',
    priceType: 'paid',
    link: 'https://www.fundedtradingplus.com?ref=TUHAO09',
    logoIcon: 'ri-funds-line',
    logoGrad: 'from-green-500 to-emerald-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/0c6934bf-95ce-43d7-ba26-c4f54a3217fe_funded-trading-plus.jpg?v=47762e0686fc075d63f0faeadb2c9385',
    badge: 'Popular',
    badgeColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    name: 'GoatFundedTrader',
    slug: 'goatfundedtrader',
    tagline: 'GOAT Funded Trader – Crypto & Forex Prop Firm',
    desc: 'GoatFundedTrader combines crypto and forex prop trading in one platform. Get funded accounts for both markets with competitive profit splits, fast payouts, and a supportive trader community.',
    tags: ['Prop Trading', 'Crypto', 'Forex', 'Funded Account'],
    rating: 4.5,
    reviews: 890,
    price: 'From $59',
    priceType: 'paid',
    link: 'https://checkout.goatfundedtrader.com/aff/CTTNHHKYTHUATSO247/',
    logoIcon: 'ri-shield-star-line',
    logoGrad: 'from-lime-500 to-green-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/d90f8c29-f71f-4fa6-ab55-5df9b5bf8dcd_goat-funder-trader.png?v=964b285af142f1076bbde4afb5f0fb9f',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'TradingFunds',
    slug: 'tradingfunds',
    tagline: 'Next-Gen Prop Funding Platform',
    desc: 'TradingFunds is a modern proprietary trading platform that connects skilled traders with capital. Offering streamlined evaluations, fast account activation, and up to 85% profit share on funded accounts.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'Challenge'],
    rating: 4.4,
    reviews: 720,
    price: 'From $49',
    priceType: 'paid',
    link: 'https://tradingfunds.com/aff/1151/',
    logoIcon: 'ri-money-dollar-circle-line',
    logoGrad: 'from-teal-400 to-emerald-500',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/6b2f3645-3d1a-4798-bb06-0abe24d449d1_trading-funds.png?v=06c15293c5778f2a506a0d7faa755a47',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'AlphaFunded',
    slug: 'alphafunded',
    tagline: 'Alpha Funded – Professional Trader Evaluation',
    desc: 'AlphaFunded provides professional evaluation programs for forex and CFD traders seeking funded accounts. Competitive drawdown rules, transparent payouts, and multiple account sizes to fit your trading style.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'Evaluation'],
    rating: 4.5,
    reviews: 980,
    price: 'From $79',
    priceType: 'paid',
    link: 'https://alphafunded.com/ref/luuan.492502%40gmail.com/',
    logoIcon: 'ri-bar-chart-2-line',
    logoGrad: 'from-cyan-500 to-teal-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/0cd0dfce-0c66-4e21-87ee-e03514b422e7_alpha-trader.png?v=8ab9cd30de2eff899c3ee2b05041095f',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'CryptoFundTrader',
    slug: 'cryptofundtrader',
    tagline: 'Crypto Prop Trading Pioneer',
    desc: 'CryptoFundTrader is a pioneer in crypto-focused proprietary trading, offering funded accounts for Bitcoin, Ethereum, and altcoin traders. No time limits on challenges and competitive profit splits.',
    tags: ['Prop Trading', 'Crypto', 'Bitcoin', 'Funded Account'],
    rating: 4.4,
    reviews: 650,
    price: 'From $129',
    priceType: 'paid',
    link: 'https://cryptofundtrader.com?_by=an59',
    logoIcon: 'ri-bit-coin-line',
    logoGrad: 'from-orange-500 to-amber-500',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/acb336af-c827-4ec7-97a0-a143b4d3ec4d_crypto-fund-trader.png?v=ca8da57a8214e583fd645b67a3f68eed',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'HashHedge',
    slug: 'hashhedge',
    tagline: 'HashHedge – Smart Prop Trading Solutions',
    desc: 'HashHedge offers innovative prop trading solutions with hedging-friendly rules and multiple trading styles supported. Get funded accounts with generous drawdown allowances and bi-weekly profit payouts.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'Hedging'],
    rating: 4.3,
    reviews: 540,
    price: 'From $89',
    priceType: 'paid',
    link: 'https://hashhedge.com?fpr=2903042000win_www',
    logoIcon: 'ri-safe-2-line',
    logoGrad: 'from-green-600 to-teal-700',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/cc1749e0-4ef7-40a2-94eb-3d274d7964b3_hash-hedge.png?v=6d06ffbc24a379d04ac4a3788e44526d',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'FundedTraderMarkets',
    slug: 'fundedtradermarkets',
    tagline: 'The Funded Trader – Scale to $1.5M',
    desc: 'FundedTraderMarkets is one of the leading prop firms offering funded accounts up to $1.5M. Multiple evaluation programs, high profit splits, and a scaling plan to grow your trading capital over time.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'Scaling'],
    rating: 4.6,
    reviews: 1670,
    price: 'From $65',
    priceType: 'paid',
    link: 'https://www.fundedtradermarkets.com/ref/LAMLAM2648',
    logoIcon: 'ri-stock-line',
    logoGrad: 'from-emerald-600 to-green-700',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/f08d1549-c02b-492b-aea9-aae5f3127fff_funded-trader-market.jpg?v=69a7a8b0757ebb7b4f9a08a262b27177',
    badge: 'Popular',
    badgeColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    name: 'AtlasFunded',
    slug: 'atlasfunded',
    tagline: 'Atlas Funded – Professional Forex Funding',
    desc: 'AtlasFunded provides professional funding solutions for forex traders worldwide. Multiple challenge tiers, instant funding options, and a 24/7 support team helping traders maximize their performance.',
    tags: ['Prop Trading', 'Funded Account', 'Forex', 'Instant Funding'],
    rating: 4.4,
    reviews: 830,
    price: 'From $149',
    priceType: 'paid',
    link: 'https://atlasfunded.com/?afmc=team247',
    logoIcon: 'ri-global-line',
    logoGrad: 'from-teal-500 to-cyan-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/906a02e2-869d-4995-b3bf-9e04bedb5eef_atlas-funded.jpg?v=073182c15e8fdf101fb8813e171297cc',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'FundingTicks',
    slug: 'fundingticks',
    tagline: 'FundingTicks – Futures Prop Challenge',
    desc: 'FundingTicks specializes in futures prop trading evaluations with no time restrictions on the challenge phase. Competitive funded account sizes, clear rules, and fast withdrawal processing for successful traders.',
    tags: ['Prop Trading', 'Futures', 'Funded Account', 'Challenge'],
    rating: 4.3,
    reviews: 610,
    price: 'From $49',
    priceType: 'paid',
    link: 'https://app.fundingticks.com/register?ref=12BC9CF9',
    logoIcon: 'ri-timer-line',
    logoGrad: 'from-lime-600 to-green-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/bf9c068a-a7e9-45e3-9911-da1a50653a14_fungding-ticks.png?v=3de9c2c42aec44f1eb1c5dd5b5e47663',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'DominionFunding',
    slug: 'dominionfunding',
    tagline: 'Dominion Funding – Forex & Crypto Trading',
    desc: 'Dominion Funding offers prop trading opportunities for both forex and crypto traders. Affordable evaluation fees, flexible trading conditions, and up to 80% profit split on all funded accounts.',
    tags: ['Prop Trading', 'Forex', 'Crypto', 'Funded Account'],
    rating: 4.2,
    reviews: 490,
    price: 'From $79',
    priceType: 'paid',
    link: 'https://dominionfunding.trade/?affId=5912EJEvET',
    logoIcon: 'ri-copper-diamond-line',
    logoGrad: 'from-green-500 to-lime-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/de546bb6-061d-4f98-a57b-8cc8ce52180e_dominion.jpg?v=56d969bae33c001688b2ce34ebdbce28',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'Quanttekel',
    slug: 'quanttekel',
    tagline: 'Quanttekel – Quant-Driven Funded Challenges',
    desc: 'Quanttekel brings a data-driven approach to proprietary trading evaluations. Supporting algorithmic and manual strategies, Quanttekel offers funded accounts with transparent metrics and flexible challenge rules.',
    tags: ['Prop Trading', 'Quant Trading', 'Funded Account', 'Challenge'],
    rating: 4.4,
    reviews: 700,
    price: 'From $99',
    priceType: 'paid',
    link: 'https://qtfunded.quanttekel.com/ref/4547/?campaign=QT1',
    logoIcon: 'ri-database-2-line',
    logoGrad: 'from-teal-600 to-emerald-700',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/8d2b69e2-862d-455a-a4cb-c4ed9cc4f11d_qt-funded.png?v=9388ce702f3bdd4ea9060cec234e4a6f',
    badge: '',
    badgeColor: '',
  },
  // ── CRYPTO EXCHANGES ──
  {
    name: 'CoinEx',
    slug: 'coinex',
    tagline: 'Global Crypto Exchange with 700+ Trading Pairs',
    desc: 'CoinEx is a global cryptocurrency exchange supporting 700+ trading pairs with spot, futures, margin, and AMM trading. Low trading fees, fast execution, and excellent customer support for traders of all levels.',
    tags: ['Crypto Exchange', 'Spot Trading', 'Futures', 'Altcoins'],
    rating: 4.5,
    reviews: 3200,
    price: 'Free · Maker 0.16%',
    priceType: 'free',
    link: 'https://www.coinex.com/register?rc=as2ym&channel=Referral',
    logoIcon: 'ri-exchange-line',
    logoGrad: 'from-green-500 to-emerald-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/fa8fe011-e804-43d6-8ee6-fc4a176918b5_coinex.webp?v=40be14863768b1b051a1a009451f0639',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'Bybit',
    slug: 'bybit',
    tagline: 'World-Class Crypto Derivatives Exchange',
    desc: 'Bybit is a world-leading crypto derivatives exchange offering perpetual contracts, futures, and spot trading with up to 100x leverage. Trusted by 25M+ traders globally with institutional-grade security and performance.',
    tags: ['Crypto Exchange', 'Derivatives', 'Perpetual', 'Leverage'],
    rating: 4.8,
    reviews: 8450,
    price: 'Free · Maker 0.01%',
    priceType: 'free',
    link: 'https://www.bybit.com/invite?ref=E5XWLZN',
    logoIcon: 'ri-rocket-2-line',
    logoGrad: 'from-teal-500 to-cyan-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/bee96764-61cd-44ae-8af5-6cc2f005b709_bybit.png?v=7984d7ddcee0b3ef69aee23ba24bc244',
    badge: 'Hot',
    badgeColor: 'bg-red-100 text-red-700',
  },
  {
    name: 'Bitget',
    slug: 'bitget',
    tagline: 'Leading Crypto Copy Trading Exchange',
    desc: 'Bitget is the world\'s No.1 crypto copy trading platform with 800+ elite traders to follow. Offering spot, futures, and one-click copy trading with up to 125x leverage across 700+ trading pairs.',
    tags: ['Copy Trading', 'Crypto Exchange', 'Futures', 'Social'],
    rating: 4.7,
    reviews: 6320,
    price: 'Free · Maker 0.02%',
    priceType: 'free',
    link: 'https://share.bitget.com/u/HAP7VDAY',
    logoIcon: 'ri-user-follow-line',
    logoGrad: 'from-cyan-500 to-teal-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/a7a00e5c-53cc-4ed8-b37a-ef079fa36627_bitget.png?v=0f62efbd9e8d7b5622774fb679a1e979',
    badge: 'Popular',
    badgeColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    name: 'OKX',
    slug: 'okx',
    tagline: 'All-in-One Crypto & Web3 Platform',
    desc: 'OKX is a comprehensive crypto and Web3 platform combining spot, derivatives, options, and a full DeFi ecosystem. Offering 350+ trading pairs, a built-in Web3 wallet, and NFT marketplace for advanced crypto users.',
    tags: ['Crypto Exchange', 'Web3', 'Futures', 'DeFi'],
    rating: 4.7,
    reviews: 7890,
    price: 'Free · Maker 0.08%',
    priceType: 'free',
    link: '#',
    logoIcon: 'ri-apps-2-line',
    logoGrad: 'from-gray-700 to-gray-900',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/b685a92f-2332-43e2-b188-69e3c53d07b1_okx.png?v=baa8e4c9b94b41b84d3a8b2dbdefbb74',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'MEXC',
    slug: 'mexc',
    tagline: 'Fast & Low-Fee Crypto Exchange',
    desc: 'MEXC is known for listing emerging altcoins early and offering 0% maker fees on futures. With 1,700+ trading pairs, fast execution, and one of the largest selections of new token listings in the market.',
    tags: ['Crypto Exchange', 'Altcoins', 'Futures', 'Zero Fees'],
    rating: 4.5,
    reviews: 4120,
    price: 'Free · Maker 0%',
    priceType: 'free',
    link: 'https://www.mexc.com/vi-VN/auth/signup?inviteCode=3njLG',
    logoIcon: 'ri-flashlight-line',
    logoGrad: 'from-green-500 to-lime-500',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/5ed98061-798c-4ae1-aa26-386110042cbd_mc.png?v=43374b965777f0855c02d71e5ea6b6b6',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'BingX',
    slug: 'bingx',
    tagline: 'Social Crypto Copy Trading Platform',
    desc: 'BingX is a social crypto trading platform integrating copy trading, spot, and perpetual futures. Follow top-performing traders, automate your strategy, and access grid trading bots for passive income.',
    tags: ['Copy Trading', 'Crypto Exchange', 'Social', 'Grid Bot'],
    rating: 4.4,
    reviews: 2890,
    price: 'Free · Copy Trading',
    priceType: 'free',
    link: 'https://bingxdao.com/invite/84KFAD/',
    logoIcon: 'ri-share-circle-line',
    logoGrad: 'from-teal-400 to-cyan-500',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/0dd6d875-b521-4f9e-8e55-757ea7fd9383_bingx.png?v=77b9456021cb391534eb1b64516e4ac8',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'HTX',
    slug: 'htx',
    tagline: 'HTX (Huobi) – Veteran Global Crypto Exchange',
    desc: 'HTX (formerly Huobi Global) is one of the oldest and most trusted cryptocurrency exchanges with 10+ years of operation. Offering spot, futures, options, staking, and DeFi services to millions of users worldwide.',
    tags: ['Crypto Exchange', 'Spot', 'Staking', 'Veteran'],
    rating: 4.4,
    reviews: 5670,
    price: 'Free · Maker 0.2%',
    priceType: 'free',
    link: 'https://www.htx.com/invite/vi-vi/1f?invite_code=mz42c223',
    logoIcon: 'ri-building-4-line',
    logoGrad: 'from-emerald-500 to-green-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/6e9c4a6c-249f-4d4a-a004-1f4367dc7cc9_htx.png?v=c399301e4ba736b1e5f0219caef371ea',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'Binance',
    slug: 'binance',
    tagline: "World's Largest Crypto Exchange",
    desc: "Binance is the world's largest cryptocurrency exchange by trading volume, serving 170M+ users in 180+ countries. Offering 350+ coins, spot and derivatives trading, staking, Launchpad, DeFi, and a native BNB ecosystem.",
    tags: ['Crypto Exchange', 'Spot', 'DeFi', 'Largest'],
    rating: 4.9,
    reviews: 42000,
    price: 'Free · Maker 0.02%',
    priceType: 'free',
    link: 'https://accounts.binance.com/register?ref=1210734451',
    logoIcon: 'ri-coin-line',
    logoGrad: 'from-yellow-500 to-amber-500',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/b873056d-1cfc-4c3a-b8e9-fea360333125_binance.png?v=d754211d655125eff2d52202d28aabe3',
    badge: '#1 Global',
    badgeColor: 'bg-amber-100 text-amber-700',
  },
  {
    name: 'KuCoin',
    slug: 'kucoin',
    tagline: "The People's Crypto Exchange",
    desc: "KuCoin is known as the People's Exchange with 700+ listed cryptocurrencies and a strong focus on emerging assets. Features spot, futures, margin trading, lending, staking, and a popular crypto lending marketplace.",
    tags: ['Crypto Exchange', 'Altcoins', 'Futures', 'Lending'],
    rating: 4.6,
    reviews: 9870,
    price: 'Free · Maker 0.02%',
    priceType: 'free',
    link: 'https://www.kucoin.com/r/af/rEMF6SL',
    logoIcon: 'ri-community-line',
    logoGrad: 'from-teal-500 to-emerald-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/341b310c-4119-44c6-885c-957b54193da3_kucoin.png?v=1efd48ceee3a75c30c48e8a35af128dc',
    badge: 'Popular',
    badgeColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    name: 'Phemex',
    slug: 'phemex',
    tagline: 'Professional Crypto Trading & Options',
    desc: 'Phemex is a professional-grade crypto exchange founded by former Morgan Stanley executives. Offering zero-fee spot trading for Premium members, ultra-fast order matching, and a growing options trading market.',
    tags: ['Crypto Exchange', 'Options', 'Futures', 'Premium'],
    rating: 4.5,
    reviews: 3450,
    price: 'Free · Premium $7.99/mo',
    priceType: 'free',
    link: 'https://phemex.com/register?referralCode=CPV9H9&scene=referral',
    logoIcon: 'ri-award-line',
    logoGrad: 'from-cyan-500 to-teal-700',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/7ad9412b-e293-42e1-90e2-aab77620545a_phemex.png?v=fd05fd972cafa7f55686157aeeeecba2',
    badge: '',
    badgeColor: '',
  },
  {
    name: 'Bitunix',
    slug: 'bitunix',
    tagline: 'Next-Gen Crypto Futures Exchange',
    desc: 'Bitunix is an emerging next-generation cryptocurrency futures exchange offering ultra-low trading fees, copy trading functionality, and up to 200x leverage. Ideal for active traders seeking high-performance derivatives.',
    tags: ['Crypto Exchange', 'Futures', 'Derivatives', 'Copy Trading'],
    rating: 4.3,
    reviews: 890,
    price: 'Free · Maker 0.01%',
    priceType: 'free',
    link: 'https://www.bitunix.com/register?inviteCode=uqe4bk',
    logoIcon: 'ri-terminal-box-line',
    logoGrad: 'from-green-600 to-teal-700',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/039146fc-891b-48e0-8081-f48295b42ffa_bitunix.png?v=5afcac27150e3be2acd4d31f0f7fa9ce',
    badge: 'New',
    badgeColor: 'bg-teal-100 text-teal-700',
  },
  {
    name: 'XM',
    slug: 'xm',
    tagline: 'Global Forex & CFD Broker – 10M+ Clients',
    desc: 'XM is a globally regulated forex and CFD broker trusted by 10M+ clients in 196 countries. Offering MetaTrader 4/5, forex, commodities, stocks, indices, and ultra-low spreads with up to 1:1000 leverage.',
    tags: ['Forex Broker', 'CFD', 'MT4/MT5', 'Regulated'],
    rating: 4.6,
    reviews: 7230,
    price: 'Free · Variable spreads',
    priceType: 'free',
    link: 'https://www.xmvnmarket.com/referral?token=2--otshOonS-VgblNEn1Yw',
    logoIcon: 'ri-earth-line',
    logoGrad: 'from-emerald-500 to-teal-600',
    logoUrl: 'https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/bb3a9eac-5167-42eb-b14a-a6cec2212d9b_xm.jpg?v=6b1735cf6684e2fd7c01bd619c490fac',
    badge: 'Regulated',
    badgeColor: 'bg-teal-100 text-teal-700',
  },
];

const relatedCategories = [
  {
    icon: 'ri-robot-2-line',
    grad: 'from-violet-500 to-purple-600',
    name: 'Software – SaaS – AI',
    desc: 'AI-powered platforms, cloud software, and SaaS tools to automate your work',
    count: 54,
    href: '/categories/software-saas-ai',
  },
  {
    icon: 'ri-shopping-cart-2-line',
    grad: 'from-orange-400 to-amber-500',
    name: 'Ecommerce & Shopping',
    desc: 'Online stores, marketplaces, and shopping platforms for digital commerce',
    count: 126,
    href: '/categories',
  },
  {
    icon: 'ri-graduation-cap-line',
    grad: 'from-sky-500 to-blue-600',
    name: 'Education & Learning',
    desc: 'Online courses, learning platforms, and certification programs worldwide',
    count: 94,
    href: '/categories',
  },
];

type FilterTab = 'all' | 'free' | 'popular';
type SortOption = 'highest_rating' | 'most_reviews' | 'default';

export default function FinanceInvestmentPage() {
  const { i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [signUpEmail, setSignUpEmail] = useState('');
  const [signUpPassword, setSignUpPassword] = useState('');
  const [signUpDone, setSignUpDone] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [filterTab, setFilterTab] = useState<FilterTab>('all');
  const [sortBy, setSortBy] = useState<SortOption>('highest_rating');
  const [sortOpen, setSortOpen] = useState(false);
  const langRef = useRef<HTMLDivElement>(null);
  const sortRef = useRef<HTMLDivElement>(null);

  const currentLang = i18n.language === 'vi' ? 'VI' : 'EN';

  const sortLabels: Record<SortOption, string> = {
    highest_rating: 'Highest rating',
    most_reviews: 'Most reviews',
    default: 'Default',
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (langRef.current && !langRef.current.contains(e.target as Node)) setLangOpen(false);
      if (sortRef.current && !sortRef.current.contains(e.target as Node)) setSortOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = tools
    .filter((t) => {
      if (filterTab === 'free') return t.priceType === 'free';
      if (filterTab === 'popular') return t.reviews >= 1500;
      return true;
    })
    .sort((a, b) => {
      if (sortBy === 'highest_rating') return b.rating - a.rating;
      if (sortBy === 'most_reviews') return b.reviews - a.reviews;
      return 0;
    });

  const renderStars = (rating: number) => {
    const full = Math.floor(rating);
    const half = rating - full >= 0.5;
    return Array.from({ length: 5 }).map((_, i) => {
      if (i < full) return <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>;
      if (i === full && half) return <i key={i} className="ri-star-half-line text-amber-400 text-xs"></i>;
      return <i key={i} className="ri-star-line text-gray-300 text-xs"></i>;
    });
  };

  const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

  const pageSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        name: 'Finance – Investment Tools | 247digitrend',
        url: `${siteUrl}/categories/finance-investment`,
        description:
          'Discover and compare the best finance and investment platforms. Prop trading firms, crypto exchanges, and forex brokers reviewed with ratings and honest analysis.',
        isPartOf: { '@id': `${siteUrl}/#website` },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Categories', item: `${siteUrl}/categories` },
            { '@type': 'ListItem', position: 3, name: 'Finance – Investment', item: `${siteUrl}/categories/finance-investment` },
          ],
        },
      },
      {
        '@type': 'ItemList',
        name: 'Best Finance & Investment Platforms 2026',
        url: `${siteUrl}/categories/finance-investment`,
        numberOfItems: tools.length,
        itemListElement: tools.map((t, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: t.name,
          url: `${siteUrl}/categories/finance-investment/${t.slug}`,
          item: {
            '@type': 'FinancialProduct',
            name: t.name,
            description: t.tagline,
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: t.rating,
              reviewCount: t.reviews,
              bestRating: 5,
            },
          },
        })),
      },
    ],
  };

  return (
    <div className="min-h-screen" style={{ background: '#f0fdf9', fontFamily: "'Inter', sans-serif" }}>
      <PageMeta
        title="Best Finance & Investment Platforms (2026) – Prop Trading, Crypto, Forex | 247digitrend"
        description="Compare the best finance and investment platforms in 2026. Expert reviews of Bybit, Binance, Bitget, The5ers, OneUpTrader and 20+ more. Ratings, fees, and honest analysis."
        canonical={`${siteUrl}/categories/finance-investment`}
        keywords="best prop trading firms 2026, crypto exchange comparison, forex broker review, Bybit review, Binance review, funded trader review"
      />
      <JsonLd data={pageSchema} />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />

      {/* ── SIGN UP MODAL ── */}
      {showSignUp && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={() => { setShowSignUp(false); setSignUpDone(false); }}>
          <div className="relative bg-white rounded-2xl w-full max-w-sm mx-4 p-8" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => { setShowSignUp(false); setSignUpDone(false); }} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer">
              <i className="ri-close-line text-gray-600 text-base"></i>
            </button>
            {signUpDone ? (
              <div className="text-center py-4">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-emerald-100">
                  <i className="ri-check-line text-emerald-600 text-2xl"></i>
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-2">Registration Successful!</h3>
                <p className="text-sm text-gray-500">Welcome to 247digitrend.</p>
                <button onClick={() => { setShowSignUp(false); setSignUpDone(false); }} className="mt-6 w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-semibold py-3 rounded-full cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">Close</button>
              </div>
            ) : (
              <>
                <div className="text-center mb-6">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500">
                    <i className="ri-line-chart-line text-white text-base"></i>
                  </div>
                  <h3 className="text-xl font-black text-gray-900 mb-1">Create Account</h3>
                  <p className="text-xs text-gray-500">Join 50K+ users of 247digitrend</p>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); setSignUpDone(true); }} className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Email</label>
                    <input type="email" required value={signUpEmail} onChange={(e) => setSignUpEmail(e.target.value)} placeholder="your@email.com" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl outline-none focus:border-emerald-400 transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Password</label>
                    <input type="password" required value={signUpPassword} onChange={(e) => setSignUpPassword(e.target.value)} placeholder="At least 8 characters" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl outline-none focus:border-emerald-400 transition-colors" />
                  </div>
                  <button type="submit" className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-semibold py-3 rounded-full cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap mt-2">Sign Up Now</button>
                </form>
                <p className="text-xs text-center text-gray-400 mt-4">By signing up, you agree to our <a href="#" className="text-emerald-600 underline">Terms</a>.</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── HEADER ── */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-gray-100' : 'bg-white/90 border-b border-emerald-100'}`}>
        <div className="mx-auto px-8 py-2 flex items-center justify-between">
          <a href="/" className="flex items-center cursor-pointer">
            <img src="https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/7544398a-500f-41a6-81c3-aa7efbf1c0d2_logo-247.png?v=04135332188f9bc8b00780c66cd5837d" alt="247digitrend" className="h-36 w-auto object-contain" />
          </a>
          <nav className="hidden md:flex items-center gap-8">
            <a href="/" className="text-[15px] font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">Home</a>
            <a href="/categories" className="text-[15px] font-semibold text-emerald-600 transition-colors cursor-pointer">Categories</a>
            <a href="/reviews" className="text-[15px] font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">Reviews</a>
            <a href="/comparisons" className="text-[15px] font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">Comparisons</a>
            <a href="/blog" className="text-[15px] font-medium text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">Blog</a>
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer">
              <i className="ri-search-line text-gray-500 text-sm"></i>
            </button>
          </nav>
          <div className="flex items-center gap-3">
            <div className="relative" ref={langRef}>
              <button onClick={() => setLangOpen(!langOpen)} className="flex items-center gap-1.5 bg-gray-100 hover:bg-gray-200 transition-colors rounded-full px-3 py-1.5 cursor-pointer">
                <i className="ri-translate-2 text-xs text-gray-500"></i>
                <span className="text-xs font-semibold text-gray-700">{currentLang}</span>
                <i className={`ri-arrow-down-s-line text-xs text-gray-400 transition-transform ${langOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {langOpen && (
                <div className="absolute right-0 top-full mt-1.5 bg-white rounded-xl border border-gray-100 overflow-hidden w-32" style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.08)' }}>
                  {(['VI', 'EN'] as const).map((lang) => (
                    <button key={lang} onClick={() => { i18n.changeLanguage(lang.toLowerCase()); setLangOpen(false); }} className={`w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold transition-colors cursor-pointer ${currentLang === lang ? 'bg-emerald-50 text-emerald-700' : 'text-gray-600 hover:bg-gray-50'}`}>
                      <span>{lang === 'VI' ? '🇻🇳' : '🇺🇸'}</span>
                      <span>{lang === 'VI' ? 'Tiếng Việt' : 'English'}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button onClick={() => setShowSignUp(true)} className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm font-semibold px-5 py-2 rounded-full whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity">
              Sign Up
            </button>
          </div>
        </div>
      </header>

      {/* ── PAGE CONTENT ── */}
      <main className="pt-28 pb-16">
        <div className="max-w-5xl mx-auto px-6">

          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 mb-6">
            <a href="/" className="w-7 h-7 flex items-center justify-center rounded-lg bg-white border border-emerald-100 hover:border-emerald-300 transition-colors cursor-pointer">
              <i className="ri-home-4-line text-gray-500 text-xs"></i>
            </a>
            <i className="ri-arrow-right-s-line text-gray-400 text-sm"></i>
            <a href="/categories" className="w-7 h-7 flex items-center justify-center rounded-lg bg-white border border-emerald-100 hover:border-emerald-300 transition-colors cursor-pointer">
              <i className="ri-apps-2-line text-gray-500 text-xs"></i>
            </a>
          </nav>

          {/* Category Header */}
          <div className="mb-8">
            {/* Accent bar */}
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1 h-6 rounded-full bg-gradient-to-b from-emerald-500 to-teal-600"></div>
              <span className="text-xs font-bold text-emerald-600 uppercase tracking-widest">Finance Category</span>
            </div>
            <h1 className="text-3xl font-black text-gray-900 mb-2 tracking-tight">Finance – Investment</h1>
            <p className="text-sm text-gray-500 mb-4">Prop trading firms, cryptocurrency exchanges, forex brokers, and investment platforms for serious traders</p>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1.5 bg-white border border-emerald-200 rounded-full px-3 py-1.5">
                <i className="ri-tools-line text-emerald-500 text-xs"></i>
                <span className="text-xs font-semibold text-gray-700">{tools.length} platforms</span>
              </div>
              <div className="flex items-center gap-1.5 bg-amber-50 border border-amber-200 rounded-full px-3 py-1.5">
                <i className="ri-star-fill text-amber-500 text-xs"></i>
                <span className="text-xs font-semibold text-amber-700">Highly rated</span>
              </div>
              <div className="flex items-center gap-1.5 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1.5">
                <i className="ri-shield-check-line text-emerald-600 text-xs"></i>
                <span className="text-xs font-semibold text-emerald-700">Verified platforms</span>
              </div>
            </div>
          </div>

          {/* Filter + Sort Bar */}
          <div className="flex items-center justify-between mb-6">
            {/* Filter tabs */}
            <div className="flex items-center bg-white border border-emerald-200 rounded-full px-1 py-1 gap-0.5">
              {(['all', 'free', 'popular'] as FilterTab[]).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setFilterTab(tab)}
                  className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all cursor-pointer whitespace-nowrap capitalize ${
                    filterTab === tab
                      ? 'bg-emerald-600 text-white'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            {/* Sort dropdown */}
            <div className="relative" ref={sortRef}>
              <button
                onClick={() => setSortOpen(!sortOpen)}
                className="flex items-center gap-2 bg-white border border-emerald-200 rounded-full px-4 py-2 text-xs font-semibold text-gray-700 hover:border-emerald-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Sort by: {sortLabels[sortBy]}</span>
                <i className={`ri-arrow-down-s-line text-gray-400 transition-transform ${sortOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {sortOpen && (
                <div className="absolute right-0 top-full mt-1.5 bg-white rounded-xl border border-gray-100 overflow-hidden w-44 z-10" style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
                  {(Object.entries(sortLabels) as [SortOption, string][]).map(([key, label]) => (
                    <button key={key} onClick={() => { setSortBy(key); setSortOpen(false); }} className={`w-full flex items-center gap-2 px-4 py-2.5 text-xs font-semibold transition-colors cursor-pointer text-left ${sortBy === key ? 'bg-emerald-50 text-emerald-700' : 'text-gray-600 hover:bg-gray-50'}`}>
                      {sortBy === key && <i className="ri-check-line text-emerald-600"></i>}
                      <span className={sortBy === key ? '' : 'ml-4'}>{label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Tools List */}
          <div className="space-y-3">
            {filtered.map((tool, i) => (
              <div key={i} className="bg-white rounded-2xl border border-emerald-100 p-5 hover:border-emerald-300 transition-all group">
                <div className="flex items-start gap-4">
                  {/* Logo */}
                  {tool.logoUrl ? (
                    <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 rounded-xl bg-white border border-gray-100 overflow-hidden p-1">
                      <img src={tool.logoUrl} alt={tool.name} className="w-full h-full object-contain" />
                    </div>
                  ) : (
                    <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 rounded-xl bg-gradient-to-br ${tool.logoGrad}`}>
                      <i className={`${tool.logoIcon} text-white text-xl`}></i>
                    </div>
                  )}

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 min-w-0">
                        {/* Name + badge */}
                        <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                          <h3 className="text-base font-bold text-gray-900">{tool.name}</h3>
                          {tool.badge && (
                            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${tool.badgeColor}`}>{tool.badge}</span>
                          )}
                        </div>
                        {/* Tagline */}
                        <p className="text-xs font-medium text-emerald-600 mb-1.5">{tool.tagline}</p>
                        {/* Description */}
                        <p className="text-xs text-gray-500 leading-relaxed line-clamp-2 mb-3">{tool.desc}</p>
                        {/* Tags */}
                        <div className="flex flex-wrap gap-1.5 mb-3">
                          {tool.tags.map((tag, ti) => (
                            <span key={ti} className="text-xs font-medium text-emerald-700 bg-emerald-50 rounded-full px-2.5 py-0.5">{tag}</span>
                          ))}
                        </div>
                        {/* Price */}
                        <p className="text-xs text-gray-500">
                          <i className="ri-price-tag-3-line mr-1 text-gray-400"></i>
                          {tool.price}
                        </p>
                      </div>

                      {/* Right: Rating + Buttons */}
                      <div className="flex flex-col items-end gap-3 flex-shrink-0">
                        {/* Rating */}
                        <div className="text-right">
                          <div className="flex items-center gap-1 justify-end mb-0.5">
                            <div className="flex items-center gap-0.5">
                              {renderStars(tool.rating)}
                            </div>
                            <span className="text-sm font-bold text-gray-800 ml-0.5">{tool.rating}</span>
                          </div>
                          <span className="text-xs text-gray-400">({tool.reviews.toLocaleString()} reviews)</span>
                        </div>

                        {/* Buttons */}
                        <div className="flex items-center gap-2">
                          <a
                            href={`/categories/finance-investment/${tool.slug}`}
                            className="flex items-center gap-1.5 px-3.5 py-2 border border-gray-300 text-gray-600 hover:border-emerald-400 hover:text-emerald-600 text-xs font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap"
                          >
                            View Details
                          </a>
                          {tool.link !== '#' ? (
                            <a
                              href={tool.link}
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              className="flex items-center gap-1.5 px-3.5 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                            >
                              <i className="ri-external-link-line text-xs"></i>
                              Access
                            </a>
                          ) : (
                            <span className="flex items-center gap-1.5 px-3.5 py-2 bg-gray-100 text-gray-400 text-xs font-semibold rounded-lg whitespace-nowrap">
                              <i className="ri-time-line text-xs"></i>
                              Soon
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {filtered.length === 0 && (
              <div className="text-center py-16 bg-white rounded-2xl border border-emerald-100">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-emerald-50">
                  <i className="ri-inbox-line text-2xl text-emerald-400"></i>
                </div>
                <p className="text-sm font-semibold text-gray-500">No platforms found</p>
                <p className="text-xs text-gray-400 mt-1">Try a different filter</p>
              </div>
            )}
          </div>

          {/* ── RELATED CATEGORIES ── */}
          <div className="mt-12">
            <h2 className="text-lg font-bold text-gray-900 mb-5">Related categories</h2>
            <div className="grid grid-cols-3 gap-4">
              {relatedCategories.map((cat, i) => (
                <a key={i} href={cat.href} className="bg-white rounded-2xl border border-emerald-100 p-5 hover:border-emerald-300 transition-all cursor-pointer group">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${cat.grad} mb-3`}>
                    <i className={`${cat.icon} text-white text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-bold text-gray-900 mb-1 group-hover:text-emerald-600 transition-colors">{cat.name}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed mb-3">{cat.desc}</p>
                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <i className="ri-tools-line"></i>
                    <span>{cat.count} tools</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* ── STATS BAR ── */}
      <section style={{ background: 'linear-gradient(135deg, #064e3b 0%, #065f46 100%)' }} className="py-10">
        <div className="max-w-4xl mx-auto px-8">
          <div className="grid grid-cols-4 gap-8 text-center">
            {[
              { num: '25', label: 'Platforms' },
              { num: '13', label: 'Prop Firms' },
              { num: '12', label: 'Exchanges' },
              { num: '100K+', label: 'Traders' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-4xl font-black text-white mb-1">{stat.num}</div>
                <div className="text-sm font-medium text-emerald-300">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ background: '#f0fdf9' }} className="pt-14 pb-6 border-t border-emerald-100">
        <div className="max-w-6xl mx-auto px-8">
          <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-emerald-100">
            <div className="md:col-span-4">
              <div className="flex items-center mb-4">
                <img src="https://storage.readdy-site.link/project_files/3785ac0c-31ac-4f9e-b2ab-27ad3777db2a/7544398a-500f-41a6-81c3-aa7efbf1c0d2_logo-247.png?v=04135332188f9bc8b00780c66cd5837d" alt="247digitrend" className="h-36 w-auto object-contain" />
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                247digitrend, operated by 247 Digital Marketing Co., Ltd., provides unbiased reviews and comparisons of online tools and digital platforms, helping businesses make informed decisions in the digital world.
              </p>
            </div>
            <div className="md:col-span-2 md:col-start-6">
              <h5 className="text-sm font-bold text-gray-800 mb-4">Resources</h5>
              {[{ label: 'All Reviews', href: '/reviews' }, { label: 'Comparisons', href: '/comparisons' }, { label: 'Categories', href: '/categories' }, { label: 'Blog', href: '/blog' }].map((item, i) => (
                <a key={i} href={item.href} className="block text-sm text-gray-500 hover:text-emerald-600 transition-colors mb-3 cursor-pointer">{item.label}</a>
              ))}
            </div>
            <div className="md:col-span-2">
              <h5 className="text-sm font-bold text-gray-800 mb-4">Company</h5>
              {[{ label: 'About Us', href: '/about' }, { label: 'Contact', href: '/contact' }, { label: 'Submit a Tool', href: '/submit-tool' }, { label: 'Advertise', href: '/advertise' }].map((item, i) => (
                <a key={i} href={item.href} className="block text-sm text-gray-500 hover:text-emerald-600 transition-colors mb-3 cursor-pointer">{item.label}</a>
              ))}
            </div>
            <div className="md:col-span-2">
              <h5 className="text-sm font-bold text-gray-800 mb-4">Follow Us</h5>
              <div className="flex items-center gap-3">
                {['ri-twitter-x-line', 'ri-linkedin-line', 'ri-facebook-line', 'ri-instagram-line'].map((icon, i) => (
                  <a key={i} href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-emerald-200 bg-white text-gray-500 hover:text-emerald-600 hover:border-emerald-300 transition-all cursor-pointer">
                    <i className={`${icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="pt-5 flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-gray-400">© 2026 247digitrend. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </footer>

      <FloatingCtaBar onSignUp={() => setShowSignUp(true)} />
    </div>
  );
}
